import { InfiniteImageCarousel } from "@shared/components/infinite-image-carousel/infinite-image-carousel";
import { AuditContactSection } from "@shared/components/landing-pages/ux-audit/audit-contact-section";
import { AuditHeroSection } from "@shared/components/landing-pages/ux-audit/audit-hero-section";
import { AuditPackages } from "@shared/components/landing-pages/ux-audit/audit-packages";
import { EducationSection } from "@shared/components/landing-pages/ux-audit/education-section";
import { ExpertsSection } from "@shared/components/landing-pages/ux-audit/experts-section";
import { PartnerCardComponent } from "@shared/components/landing-pages/ux-audit/partner-card";
import { PillarSection } from "@shared/components/landing-pages/ux-audit/pillar-section";
import { StartPackage } from "@shared/components/landing-pages/ux-audit/start-package";
import { ToolsSection } from "@shared/components/landing-pages/ux-audit/tools-section";
import { WorkshopSection } from "@shared/components/landing-pages/ux-audit/workshop-section";

export const UxAuditPage = () => {
    return (
        <main>
            <AuditHeroSection />
            <div className="py-8 lg:container">
                <InfiniteImageCarousel autoStartMode="onOverflow" animationDuration={50} justifyMode="around">
                    <PartnerCardComponent image="/static/landing-pages/ux-audit-partners/orea.svg" alt="orea-logo" />
                    <PartnerCardComponent image="/static/landing-pages/ux-audit-partners/atrea.svg" alt="atrea-logo" />
                    <PartnerCardComponent
                        image="/static/landing-pages/ux-audit-partners/centropol.svg"
                        alt="centropol-logo"
                    />
                    <PartnerCardComponent
                        image="/static/landing-pages/ux-audit-partners/refinanso.svg"
                        alt="refinanso-logo"
                    />
                    <PartnerCardComponent
                        image="/static/landing-pages/ux-audit-partners/kalkulator.svg"
                        alt="kalkulator-logo"
                    />
                    <PartnerCardComponent
                        image="/static/landing-pages/ux-audit-partners/rehatab.svg"
                        alt="rehatab-logo"
                    />
                </InfiniteImageCarousel>
            </div>
            <WorkshopSection />
            <PillarSection />
            <ToolsSection />
            <EducationSection />
            <ExpertsSection />
            <StartPackage />
            <AuditPackages />
            <AuditContactSection />
        </main>
    );
};
